import { render, staticRenderFns } from "./ClaimsVariable.vue?vue&type=template&id=74e8921c&scoped=true&"
import script from "./ClaimsVariable.vue?vue&type=script&lang=js&"
export * from "./ClaimsVariable.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsVariable.vue?vue&type=style&index=0&id=74e8921c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e8921c",
  null
  
)

export default component.exports